module.exports = "<button\r\n  *ngIf=\"viewAlert\"\r\n  (click)=\"onOpenAlert()\"\r\n  type=\"button\"\r\n  title=\"Alert Rider\"\r\n  class=\"btn btn-bg-transparent color-danger\">\r\n  <i class=\"fas fa-exclamation-triangle {{emAlert}}\"></i>\r\n</button>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/rider/components/view-rider-alert/view-rider-alert.component.html
// module id = 2521
// module chunks = 66